var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBookingSucces = function SvgBookingSucces(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 37.403C72 56.51 56.51 72 37.403 72 18.295 72 2.805 56.51 2.805 37.403c0-19.108 15.49-34.598 34.598-34.598C56.51 2.805 72 18.295 72 37.403Z",
    fill: "#F7F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.117 21.506 49.09 6.546v10.96a4 4 0 0 0 4 4h10.026Z",
    fill: "#E4E9ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.428 63.792a4 4 0 0 0 4 4h39.689a4 4 0 0 0 4-4V21.506H53.09a4 4 0 0 1-4-4V6.546H19.428a4 4 0 0 0-4 4v53.246Z",
    fill: "#FBFCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.117 21.506h.5v-.197l-.136-.145-.364.342ZM49.09 6.546l.365-.343-.149-.158h-.216v.5Zm10.026 60.746H19.429v1h39.688v-1Zm-43.188-3.5V10.545h-1v53.247h1Zm46.688-42.286v42.286h1V21.506h-1Zm.864-.341L49.456 6.203l-.73.684L62.752 21.85l.73-.684Zm-10.39.841h10.026v-1H53.09v1Zm-4.5-15.46v10.96h1V6.546h-1Zm-29.163.5h29.663v-1H19.428v1Zm0 60.246a3.5 3.5 0 0 1-3.5-3.5h-1a4.5 4.5 0 0 0 4.5 4.5v-1Zm39.689 1a4.5 4.5 0 0 0 4.5-4.5h-1a3.5 3.5 0 0 1-3.5 3.5v1ZM53.09 21.007a3.5 3.5 0 0 1-3.5-3.5h-1a4.5 4.5 0 0 0 4.5 4.5v-1ZM15.928 10.545a3.5 3.5 0 0 1 3.5-3.5v-1a4.5 4.5 0 0 0-4.5 4.5h1Z",
    fill: "#E4E9ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.156 47.63a1 1 0 1 1 1.532-1.286l-1.532 1.286Zm18.234-1.286a1 1 0 0 1 1.532 1.286l-1.532-1.286Zm-17.468.643.766-.644h-.002v-.001l.003.003.02.023.095.104c.088.093.225.232.408.402.368.34.919.798 1.638 1.257 1.44.92 3.535 1.83 6.189 1.83v2c-3.128 0-5.591-1.076-7.265-2.144a13.73 13.73 0 0 1-1.92-1.475 10.406 10.406 0 0 1-.68-.69l-.011-.014-.004-.005-.002-.002.765-.644Zm9.117 2.974c2.654 0 4.748-.91 6.188-1.83.72-.46 1.271-.918 1.639-1.257a8.481 8.481 0 0 0 .503-.506l.02-.023.003-.003-.001.001s-.001.001.765.644.766.643.765.644l-.002.002-.004.005-.012.014a5.209 5.209 0 0 1-.174.192c-.117.124-.286.295-.506.498-.438.406-1.083.94-1.92 1.475-1.673 1.068-4.136 2.144-7.264 2.144v-2ZM29.462 33.242a1 1 0 0 0 .92 1.776l-.92-1.776Zm4.676 1.776a1 1 0 0 0 .92-1.776l-.92 1.776Zm-4.216-.888.46.888h-.001l.008-.004.035-.017.144-.069c.127-.058.305-.136.51-.214.438-.167.88-.285 1.182-.285v-2c-.682 0-1.409.231-1.893.415a10.031 10.031 0 0 0-.904.398l.46.888Zm2.338.299c.3 0 .743.118 1.182.285a8.105 8.105 0 0 1 .654.283l.035.017.007.004.46-.888.459-.888h-.001l-.002-.002-.005-.002a.943.943 0 0 0-.07-.035 10.031 10.031 0 0 0-.826-.358c-.485-.184-1.21-.416-1.893-.416v2ZM42.912 33.307a1 1 0 0 0 1.137 1.646l-1.137-1.646Zm4.676 1.646a1 1 0 1 0 1.136-1.646l-1.136 1.646Zm-4.108-.823.568.823.007-.004a7.051 7.051 0 0 1 .677-.394c.444-.225.847-.36 1.086-.36v-2c-.744 0-1.51.332-1.99.575a8.988 8.988 0 0 0-.891.52l-.016.011a.163.163 0 0 1-.005.004l-.002.001h-.001l.568.824Zm2.338.065c.24 0 .642.135 1.086.36a7.056 7.056 0 0 1 .684.398s.001 0 0 0l.568-.823.568-.823-.001-.001-.002-.001-.005-.004-.017-.01a8.993 8.993 0 0 0-.892-.52c-.48-.244-1.245-.576-1.989-.576v2Z",
    fill: "#B0E9E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.208 19.87h7.948M22.208 14.961h10.52",
    stroke: "#E4E9ED",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.727,
    cy: 11.688,
    r: 2.805,
    fill: "#F5FAFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.234,
    cy: 1.87,
    fill: "#F5FAFA",
    r: 1.87
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.208,
    cy: 12.623,
    fill: "#F5FAFA",
    r: 1.87
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.74,
    cy: 62.182,
    fill: "#F5FAFA",
    r: 3.74
  })));
};

export { SvgBookingSucces as ReactComponent };
export default __webpack_public_path__ + "static/media/booking-succes.52522777.svg";